import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./aigovcampusaboutwrap.css"
import anime from 'animejs/lib/anime.es.js';

const AIGovCampusAboutWrap = ( { sponsors, sponsorshipLevel }) => {

    const [learnMoreModalState,setLearnMoreModalState] = useState(false)
    const [animation, setAnimation] = useState()
    const [animationPlayed, setAnimationPlayed] = useState(false)

    const showLearnMoreModal = () => setLearnMoreModalState(true)
    const hideLearnMoreModal = () => setLearnMoreModalState(false)

    const handleScroll = () => {
        let offset = window.document.getElementById("About").getElementsByClassName("date")[0].offsetTop
        let startPoint = offset - window.scrollY
        if( startPoint <= 380 && !animationPlayed){
            // console.log('handling scroll event!')
            animation.play()
            setAnimationPlayed(!animationPlayed)
        }
    }
    useEffect( ()=>{
        // console.log('setAnimation timeline')
        /*setAnimation(anime.timeline({
            targets: ['section.about .date', 'section.about .location'],
            easing: 'cubicBezier(.5, .05, .1, .3)',
            autoplay: false
        })
        .add({
            translateX: [999, 0],
            duration: 800,
            delay: anime.stagger( 100 ),
        })
        )*/
    }, [])
    useEffect( () => {
        /*window.sponsor = sponsors
        window.sponsorshipLevel = sponsorshipLevel
        // console.log('animejs scroll eventListener added')
        window.addEventListener( 'scroll', handleScroll)
        return () => {
            // console.log('animejs scroll eventListener removed')
            window.removeEventListener( 'scroll', handleScroll)
        }*/
    })
    return (
        <section className="about" id="About">
            <div className="containfix">
                
                <div className="grid gridContain">
                    <div className="column grid1">
                        <h1>Wrap-up</h1>
                        <p className="underabout">
                        
                    <a href="https://event.on24.com/wcc/r/3147375/835DC9ADE2BC7B55DAF5CA4F2CF4C915" target="_blank" className="pinkify">Watch SNG Live: AI in State & Local On-Demand</a>. We had a great event with top tech leaders and decision makers from across state and local government and industry who explored some of the real-world applications of AI today and the outlook for AI tomorrow.<br /><br />

Our first panel, The Evolving Role of AI in Cities, featured a discussion with Joyce Edson, Executive Officer & Deputy CIO of the City of Los Angeles and Rob Silverberg, CSIO of Digital Communities at Dell Technologies.<br /><br />

Next, Maria Thompson, Chief Risk Officer of the State of North Carolina provided insights on AI-Enabled Cyber Defense.<br /><br />
                    </p>
                        
                        <p>
                            <a className="regmobwatch" href="https://event.on24.com/wcc/r/3147375/835DC9ADE2BC7B55DAF5CA4F2CF4C915" target="_blank">WATCH NOW »</a>
                        </p>
                    </div>
                    <div class="column extra_text">
                        <a className="regworkwatch" href="https://event.on24.com/wcc/r/3147375/835DC9ADE2BC7B55DAF5CA4F2CF4C915" target="_blank">WATCH NOW »</a>
                        
                    </div>
                    <div className="column grid3">
                        <div className="grouplogos">
                            <h1>SPONSORS</h1>
                            { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level && sponsor.event == "may12")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }

                        </div>
                        {/*<div className="botbuttons">
                            <h2 className="sponsor" id="Sponsors">BECOME A SPONSOR</h2>
                            <a className="pdf" href="https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                            <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>
                        </div>*/}
                    </div>
                </div>
            </div>
            <div className="sponsormob-mod" id="Sponsors">
                <div className="grouplogos">
                        <h1>SPONSORS</h1>
                        { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level  && sponsor.event == "may12")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }
                </div>
                        </div>
            <div className="sponsormob">
                <div className="containfix">
                    
                    {/*<h2 className="sponsor">BECOME A SPONSOR</h2>
                    <a className="pdf" href="https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                        <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>*/}
                </div>
            </div>
            
        </section>
    )
}

export default AIGovCampusAboutWrap